import { ENV } from "@/config/env";

/**
 * PRODUCT_DEV-641 ログイン画面が「どのテナントの画面か」を決める唯一の場所。
 *
 * ## なぜ1本に寄せるか
 *
 * 同じ優先順位（配信ホスト → パス `/:tenantId` → `?tenant=`）が
 * `LoginPage` / `AuthPageLayout` / `LoginForm` の3箇所に独立して書かれていた。
 * いまは式が同じなので一致するが、**それを保つ機械が無い**。片方だけ変えると
 * 「A 社のロゴと呼び方を出しながら B 社に対して `resolve-alias` / `signInByAlias`
 * する」画面が成立する。型検査もテストも通る壊れ方なので、判定はここだけに置く。
 */
export type LoginTenant = {
  /** ログイン対象のテナント。確定していなければ null。 */
  tenantId: string | null;
  /**
   * 配信ホストだけでテナントが決まっているか。
   * このときは生の tenantId を画面に出さない（URL とロゴで分かるので、
   * 内部 ID を顧客に見せる意味が無い）。`/{tenantId}` のパス方式は従来どおり出す。
   */
  isDedicatedDomain: boolean;
};

/**
 * @param pathTenantId `useParams().tenantId`
 * @param queryTenant  `?tenant=` の値
 */
export const resolveLoginTenant = (
  pathTenantId: string | undefined,
  queryTenant: string | null,
): LoginTenant => {
  const fixed = ENV.FIXED_TENANT_ID || null;
  return {
    tenantId: fixed || pathTenantId?.trim() || queryTenant?.trim() || null,
    isDedicatedDomain: Boolean(fixed),
  };
};

/**
 * 配信ホストだけでテナントが決まる環境か。
 * 表示の出し分けだけが要る側（`LoginForm`）はこちらを使う。
 */
export const isDedicatedDomain = (): boolean => Boolean(ENV.FIXED_TENANT_ID);
